import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findRollingArrangement } from 'actions/rollingArrangements';
import { findUser } from 'actions/users';
import { getRollingArrangement } from 'reducers';

const rollingArrangementPage = (DecoratedComponent) => {
  class RollingArrangementPage extends Component {
    componentDidMount() {
      this.fetchRollingArrangement();
      this.fetchUser();
    }

    componentDidUpdate(oldProps) {
      if (
        this.props.match.params.rollingArrangementId !==
        oldProps.match.params.rollingArrangementId
      ) {
        this.fetchRollingArrangement();
      }
    }

    fetchUser = () => {
      const { match, findUser } = this.props;
      const userId = match.params && match.params.userId;
      if (userId) {
        findUser(userId);
      }
    };

    fetchRollingArrangement() {
      const { rollingArrangementId } = this.props.match.params;
      const { findRollingArrangement } = this.props;
      findRollingArrangement(rollingArrangementId);
    }

    render() {
      const { children, ...props } = this.props;

      if (!props.rollingArrangement) {
        return <div>Loading...</div>;
      }

      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapDispatchToProps = {
    findRollingArrangement,
    findUser,
  };

  const mapStateToProps = (state, { match }) => {
    const { rollingArrangementId } = match.params;
    const rollingArrangement = getRollingArrangement(
      state,
      rollingArrangementId,
    );
    const userId = rollingArrangement && rollingArrangement.user_profile;

    return {
      rollingArrangement,
      userId,
      user: {
        id: userId,
      },
      isUserEditPage: match.params && match.params.userId,
    };
  };

  RollingArrangementPage = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RollingArrangementPage);

  return RollingArrangementPage;
};

export default rollingArrangementPage;
